<template>
  <base-table :data="getLogsOCPI">
    <el-table-column
      prop="party_id"
      :label="$t('sections.logs.table.partyId')"
      width="150%"
    />
    <el-table-column
      prop="direction"
      :label="$t('sections.logs.table.direction')"
      width="150%"
    />
    <el-table-column
      prop="module"
      :label="$t('sections.logs.table.module')"
      width="200%"
    />
    <el-table-column
      prop="method"
      :label="$t('sections.logs.table.method')"
      width="150%"
    />
    <el-table-column :label="$t('sections.logs.table.dateTime')" width="220%">
      <template slot-scope="props">
        {{
          props.row.timestamp
            ? formatTime(props.row.timestamp)
            : props.row.timestamp
        }}
      </template>
    </el-table-column>
    <el-table-column :label="$t('sections.logs.table.logs')">
      <template slot-scope="props">
        {{
          JSON.parse(props.row.logs).payload
        }}
      </template>
    </el-table-column>
  </base-table>
</template>
<script>
import { formatTime } from '@/utils';
import { mapGetters } from 'vuex';

export default {
  name: 'LogsTableOCPI',
  data() {
    return {};
  },
  computed: {
    ...mapGetters(['getLogsOCPI']),
  },
  methods: {
    formatTime,
  },
};
</script>
<style lang="scss" scoped></style>
